/**
 * 将毫秒数转成天时分
 * @param msec
 */
export const msecToTimeSpan = (msec) => {
    if (msec) {
        const days = Math.floor(msec / (1000 * 60 * 60 * 24));
        const hours = Math.floor((msec % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.ceil((msec % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.ceil((msec % (1000 * 60)) / 1000);
        return {
            day: days, hour: hours, minute: minutes, second: seconds
        };
    }
    return '';
};
/**
 * 将毫秒数直接转换为字符串
 * @param msec
 */
export const msesToTimeStr = (msec) => {
    const dateObj = msecToTimeSpan(msec);
    let dateStr = '';
    if (dateObj) {
        if (dateObj.day !== 0) {
            dateStr += `${dateObj.day}天`;
        }
        if (dateObj.hour !== 0) {
            dateStr += `${dateObj.hour}时`;
        }
        if (dateObj.minute !== 0) {
            dateStr += `${dateObj.minute}分`;
        }
    }
    return dateStr;
};
/**
 * 格式化毫秒数为day-hour-minute
 * @param time
 */
export const timeTranslate = (time) => {
    const _t = msecToTimeSpan(time);
    let str = '';
    if (time === 0)
        return '1分钟';
    const _day = `${_t.day === 0 ? '' : `${Math.abs(_t.day)}天`}`;
    let _hour = `${Math.abs(_t.hour)}时`;
    if (_t.day === 0 && _t.hour === 0) {
        _hour = '';
    }
    const _minute = `${_t.minute === 0 ? 1 : Math.abs(_t.minute)}分钟`;
    str = `${_day}${_hour}${_minute}`;
    return str;
};
/**
 * @desc 时间位数不够补0
 */
export const zeroFormat = (str) => {
    if (typeof str !== 'number')
        return null;
    str = str.toString();
    return str.length === 1 ? `0${str}` : str;
};
/*
  * 小数点后不足位补0函数
  */
export const addZero = (str, num) => {
    if (str.indexOf('.') === -1) {
        let zero = '';
        for (var i = 0; i < num; i++) {
            zero += '0';
        }
        return `${str}.${zero}`;
    }
    else {
        const numLength = str.split('.')[1].length;
        if (numLength < num) {
            let zero = '';
            for (var i = 0; i < num - numLength; i++) {
                zero += '0';
            }
            return `${str}${zero}`;
        }
        return str;
    }
};
/*
 * 根据key值获取对象对应的值
 */
export const recursionSearch = (obj, code) => {
    for (let key in obj) {
        if (key === code) {
            return obj[key];
        }
        else {
            if (typeof obj[key] === "object") {
                let temp = recursionSearch(obj[key], code);
                if (temp) {
                    return temp;
                }
            }
        }
    }
};
/**
    * @description: 递归遍历查找数组对象的某个值
    * @param {string} code
    * @param {array} arr
    * @returns {object}
    */
export const filterTableMater = (code, arr) => {
    arr = arr.filter((ower) => {
        if (ower)
            return ower;
    });
    for (const item of arr) {
        if (item.key === code)
            return item;
        if (item.children && item.children.length) {
            const _item = filterTableMater(code, item.children);
            if (_item)
                return _item;
        }
    }
};
/*
 * 根据key值获取对象对应的值
 */
export const recursionSearchEx = (obj, code) => {
    if (Array.isArray(obj)) {
        obj.forEach(item => {
        });
    }
    else {
        for (let key in obj) {
            if (key === code) {
                return obj[key];
            }
            else {
                if (typeof obj[key] === "object") {
                    let temp = recursionSearch(obj[key], code);
                    if (temp) {
                        return temp;
                    }
                }
                else if (Array.isArray(obj[key])) {
                }
            }
        }
    }
};
export const getFileUrl = (file) => {
    let url = '';
    //@ts-ignore
    if (window.createObjectURL) {
        //@ts-ignore
        url = window.createObjectURL(file);
        //@ts-ignore
    }
    else if (window.URL) {
        //@ts-ignore
        url = window.URL.createObjectURL(file);
        //@ts-ignore
    }
    else if (window.webkitURL) {
        //@ts-ignore
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
};
export const throttle = (fn, delay, isDebounce) => {
    let timer;
    let lastCall = 0;
    return (...args) => {
        if (isDebounce) {
            if (timer)
                clearTimeout(timer);
            timer = setTimeout(() => {
                fn(...args);
            }, delay);
        }
        else {
            const now = new Date().getTime();
            if (now - lastCall < delay)
                return;
            lastCall = now;
            fn(...args);
        }
    };
};
export function debounce(fn, delay = 50) {
    let timer = null;
    return function () {
        let args = arguments;
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => {
            //@ts-ignore
            fn.apply(this, args);
        }, delay);
    };
}
/**
 * 生成uuid
 * @param {number} len 长度
 * @param {number} radix 进制
 * @returns {string} uuid
 */
export const uuid = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [], i;
    let local_uuid = localStorage.getItem('yunshu-system-uuid');
    radix = radix || chars.length;
    // 有uuid就直接取
    if (local_uuid) {
        return local_uuid;
    }
    if (len) {
        // Compact form
        for (i = 0; i < len; i++)
            uuid[i] = chars[0 | Math.random() * radix];
    }
    else {
        // rfc4122, version 4 form
        let r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    local_uuid = uuid.join('').replace(/-/g, '');
    // 存本地
    localStorage.setItem('yunshu-system-uuid', local_uuid);
    return local_uuid;
};
// 获取文件后缀
export const getFileSuffix = (file) => {
    if (!file.name)
        return;
    const index = file.name.lastIndexOf('.');
    let suffix = file.name.substring(index + 1, file.name.length);
    suffix = suffix.toLowerCase();
    return suffix;
};
// 判断是否支持畅写预览的格式类型（documentType：返回指明文档类型，文字处理："text"、电子表格："spreadsheet"、演示文稿："presentation"）
export const isSupportCXFormat = (file) => {
    const suffix = getFileSuffix(file);
    let documentType = '';
    // 文字处理
    if (['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'epub', 'fodt', 'htm', 'html', 'mht', 'odt', 'ott', 'pdf', 'rtf', 'txt', 'xps', 'wps'].includes(suffix)) {
        documentType = 'text';
    }
    // 电子表格
    if (['csv', 'fods', 'ods', 'ots', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx'].includes(suffix)) {
        documentType = 'spreadsheet';
    }
    // 演示文稿
    if (['fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx'].includes(suffix)) {
        documentType = 'presentation';
    }
    if (!documentType) {
        // console.log("该格式附件暂不支持预览");
        return false;
    }
    else {
        //  console.log("支持预览，并返回对应的documentType");
        return documentType;
    }
};
